// extracted by mini-css-extract-plugin
export default {"icon":"Icon-module--icon--1d7da"};